// extracted by mini-css-extract-plugin
export default {"header":"styles_header__8qILu","caption":"styles_caption__yF7kJ","logo":"styles_logo__uHJaG"};